import type { ComponentProps } from 'react';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { PricesProvider } from '@fff-web/fff-payments';
import { UpgradeMembershipProvider } from '../../utils/ContextProviders/UpgradeContext';
import { UpgradeContainer } from './UpgradeContainer';

type UpgradeRootProps = ComponentProps<typeof UpgradeContainer>;

export function UpgradeRoot(props: UpgradeRootProps) {
  return (
    <PricesProvider>
      <UpgradeMembershipProvider>
        <UpgradeContainer {...props} />
      </UpgradeMembershipProvider>
    </PricesProvider>
  );
}

export default withLDConsumer()(UpgradeRoot);
